import { showSpinner, hideSpinner } from './spinner'
import API_URL from 'constants/api'
import ApiRequest from 'utils/ApiRequest'
import User from 'utils/User'

import { actionSet } from './utils'

import {
  FETCH_MENUS_REQUEST,
  FETCH_MENUS_SUCCESS,
  FETCH_MENUS_ERROR,
  ACCESS_MENUS_REQUEST,
  ACCESS_MENUS_SUCCESS,
  ACCESS_MENUS_ERROR,
  CHANGE_MENU_ITEM_SELECTION,
  FETCH_PERMISSIONS_REQUEST,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_ERROR,
} from 'actionTypes'

export const fetchMenus = (currentUser) => (dispatch) => {
  dispatch(fetchMenusRequest())

  const query = {
    title: currentUser.title,
    ldap: currentUser.username,
  }

  return new ApiRequest(currentUser.dsToken, dispatch)
    .get(API_URL.MENUS_LIST, query)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchMenusSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchMenusError(error))
      dispatch(hideSpinner())
    })
}

export const fetchMenusRequest = () => ({
  type: FETCH_MENUS_REQUEST,
})

export const fetchMenusSuccess = (data) => {
  const menu = {}

  for (let i = 0, len = data.length; i < len; i++) {
    const menuItem = data[i]
    menuItem.subItems = {}

    if (!menuItem.cdMenuParent) {
      menu[menuItem.cdMenu] = menuItem
    } else {
      if (menu[menuItem.cdMenuParent]) {
        menu[menuItem.cdMenuParent].subItems[menuItem.cdMenu] = menuItem
      }
    }
  }

  for (const menuParent in menu) {
    menu[menuParent].subItems = Object.values(menu[menuParent].subItems).sort(
      (a, b) => {
        if (a.nuOrder === undefined && b.nuOrder === undefined) {
          return 0
        }
        if (a.nuOrder === undefined) {
          return 1
        }
        if (b.nuOrder === undefined) {
          return -1
        }
        return a.nuOrder - b.nuOrder
      }
    )
  }

  new User().menu = menu

  return {
    type: FETCH_MENUS_SUCCESS,
    payload: menu,
  }
}

export const fetchMenusError = (error) => ({
  type: FETCH_MENUS_ERROR,
  payload: error,
})

// Saves menu access

export const accessMenus = (currentUser, cdMenu) => (dispatch) => {
  dispatch(accessMenusRequest())

  const query = {
    cdMenu,
    idBranch: currentUser.locationCode,
    cdLdap: currentUser.username,
    userTitle: currentUser.title,
    mdDevice: 'web',
    versionCode: -1,
  }

  return new ApiRequest(currentUser.dsToken, dispatch)
    .post(API_URL.ACCESS_MENUS, query)
    .then((response) => {
      dispatch(accessMenusSuccess(response.data))
    })
    .catch((error) => {
      dispatch(accessMenusError(error))
    })
}

export const accessMenusRequest = () => ({
  type: ACCESS_MENUS_REQUEST,
})

export const accessMenusSuccess = (data) => ({
  type: ACCESS_MENUS_SUCCESS,
  payload: data,
})

export const accessMenusError = (error) => ({
  type: ACCESS_MENUS_ERROR,
  payload: error,
})

export const setSelectedItem = (item) => (dispatch) =>
  dispatch({
    type: CHANGE_MENU_ITEM_SELECTION,
    payload: item,
  })

export const fetchPermissions = (token) => async (dispatch) => {
  try {
    dispatch(showSpinner())

    dispatch(actionSet(FETCH_PERMISSIONS_REQUEST))

    const response = await new ApiRequest(token, dispatch).get(
      API_URL.MENU_LIST_CHILDREN
    )

    return dispatch(actionSet(FETCH_PERMISSIONS_SUCCESS, response.data))
  } catch (error) {
    return dispatch(actionSet(FETCH_PERMISSIONS_ERROR, error))
  } finally {
    dispatch(hideSpinner())
  }
}

export const fetchQuickAccess = (token, ldap, mission) => (dispatch) => {
  dispatch(showSpinner())

  return new ApiRequest(token, dispatch)
    .get(
      `${API_URL.FETCH_QUICK_ACCESS}?ldap=${ldap}` +
        `&mission=${mission}` +
        `&tipShow=2`
    )
    .then(
      (data) => {
        dispatch(hideSpinner())
        return data
      },
      (error) => {
        dispatch(hideSpinner())
        throw error
      }
    )
}

export const saveQuickAccess = (token, cdLdap, menuList) => (dispatch) => {
  dispatch(showSpinner())
  const tipShow = 2

  if (menuList.length === 0) {
    const newList = [{ cdMenu: null, cdLdap: null, tipShow }]
    return new ApiRequest(token, dispatch)
      .post(API_URL.SAVE_QUICK_ACCESS, newList)
      .then(
        (data) => {
          dispatch(hideSpinner())
          return data
        },
        (error) => {
          dispatch(hideSpinner())
          throw error
        }
      )
  }
  return new ApiRequest(token, dispatch)
    .post(
      API_URL.SAVE_QUICK_ACCESS,
      menuList.map((cdMenu) => ({
        cdMenu,
        cdLdap,
        tipShow,
      }))
    )
    .then(
      (data) => {
        dispatch(hideSpinner())
        return data
      },
      (error) => {
        dispatch(hideSpinner())
        throw error
      }
    )
}
